import myAjax from "./http";
import Qs from "qs";
//Qs.stringify(params)
var myaxios = {
    getCtiy: () => myAjax.get(`UrbanDictionary/tree`),//城市
    ZjcityTree: (params) => myAjax.get(`Zj/cityTree`,params),//城市
    registerBtn: params => myAjax.post(`buyer/add`, params),//注册
    upData: (params) => myAjax.post(`upload/fileupload`, params),//上传图片  
    buyersendsms: params => myAjax.post(`buyer/sendsms`, Qs.stringify(params)),//获取验证码
    shopcarshopcarCategory: params => myAjax.get(`shopcar/shopcarCategory/${params}`),//获取购物车数量
    regionalproductisProductPower: params => myAjax.get(`regionalproduct/isProductPower?${params}`),//控销验证
    productjudgeArea: params => myAjax.post(`product/judgeArea`, params),//销售区域拦截
    ShopLogisticsexpressDetail: () => myAjax.get(`ShopLogistics/expressDetail`,),//快递鸟查询
    orderdownInvoice: (params) => myAjax.get(`order/downInvoice?orderId=${params}`,),//下载发票
    //资质
    buyerinfo: params => myAjax.get(`buyer/info/${params}`),//查询资质信息
    onSubBuyerinfo: params => myAjax.post(`buyer/info`,params),//提交资质信息
    managerlist: () => myAjax.get(`manager/list`),//查询经营范围列表
    buyeraddUserQual: params => myAjax.post(`buyer/addUserQual`, params),//上传资质图片
    //首页
    carouselcarousel: (params) => myAjax.get(`carousel/carousel?${params}`,),//查询轮播图
    homehomeclassify: (params) => myAjax.get(`home/homeclassify?${params}`,),//查询栏目
    hometopShopCase: params => myAjax.post(`home/topShopCase`,Qs.stringify(params)),//查询优质店铺
    ShopCaseallShopCase: params => myAjax.post(`ShopCase/allShopCase`,Qs.stringify(params)),//查询店铺列表
    activigetTweetsActImg: () => myAjax.post(`activi/getTweetsActImg`),//首页推荐活动
    activiactProList: (params) => myAjax.post(`activi/actProList`, params),//首页今日特推
    newsnewslist: (params) => myAjax.post(`news/newslist`, params),//查询新闻公告
    homeguess: params => myAjax.post(`home/guess`, Qs.stringify(params)),//全部商品列表
    screenshowScreen: params => myAjax.post(`screen/showScreen`, params),//首页炸屏
    producttopThree: () => myAjax.post(`product/topThree`),//查询前三关键字搜索
    //分类页
    classifylist: params => myAjax.post(`classify/list`,Qs.stringify(params)),//分类
    productprolist: params => myAjax.post(`product/prolist?${params}`,),//分类下的商品

    //活动页
    activigetAllActByBuyerId: params => myAjax.post(`activi/getAllActByBuyerId`, params),//活动列表
    activigetTweetsProduct: params => myAjax.post(`activi/getTweetsProduct`, params),//活动商品

    //购物车
    getShoppingCart: params => myAjax.get(`shopcar/shopcarlist/${params}`),//商品
    delShoppingCart: params => myAjax.delete(`shopcar/shopcars?${params}`),//商品删除
    putShoppingNum: (params) => myAjax.put(`shopcar/upnum`, params),//添加购物车单个商品数量 
    getAccount: (params) => myAjax.get(`shopcar/account?${params}`),//算钱   
    orderOrder: (params) => myAjax.post(`order/order`, params),//提交订单     
    toImage: (params) => myAjax.get(`toImage/toImage?${params}`),//获取发票图片   
    downPdf: () => myAjax.get(`toImage/downPdf`),//下载发票pdf   ?${params} 
    ordeSaveInvoicer: (params) => myAjax.post(`order/saveInvoice`, params),//存发票  
    buyerInvoice: (params) => myAjax.get(`buyer/invoice/${params}`),//客户中取发票  
    orderGetInvoice: (params) => myAjax.post(`order/getInvoice/${params}`),//订单中取发票  
    jtExpress: (params) => myAjax.get(`order/jtExpress?${params}`),//物流信息  
    updateInvoice: (params) => myAjax.post(`buyer/updateInvoice`, params),//存客户中发票  
    postProductDetails: (params) => myAjax.post(`product/proinfo`, params),//商品详情  
    orderOrderinfo: (params) => myAjax.get(`order/orderinfo/${params}`),//查询订单信息  
    delreturn: (params) => myAjax.delete(`order/delreturn?${params}`),//删除退货信息(商户拒绝、用户取消) 

    //商品详情页
    footprintAdd: (params) => myAjax.post(`footprint/add`, params),//加入足迹 
    ShopCasegetShopInfo: (params) => myAjax.get(`ShopCase/getShopInfo/${params}`),//店铺
    productproinfo: (params) => myAjax.post(`product/proinfo`, params),//商品信息
    commentComment: (params) => myAjax.post(`comment/comment`, Qs.stringify(params)),//评论列表
    collectColl: (params) => myAjax.get(`collect/coll/${params}`),//收藏列表
    collectCollPost: (params) => myAjax.post(`collect/coll`, params),//添加收藏
    collectCollDel: (params) => myAjax.delete(`collect/coll/${params}`),//移除收藏
    auditcommisionaddAudti: (params) => myAjax.post(`auditcommision/addAudti`, params),//客户申请商品审核记录
    shopcarShopcar: (params) => myAjax.post(`shopcar/shopcar`, params),//添加到购物车
    buyerAuditaddress: (params) => myAjax.get(`buyer/Auditaddress/${params}`),//查询地址
    productprobook: (params) => myAjax.get(`product/probook/${params}`),//商品说明书
    productaddPageview: (params) => myAjax.post(`product/addPageview/${params}`),//商品浏览量
    //搜索
    productsearcht: (params) => myAjax.post(`product/searcht`,Qs.stringify(params)),//搜索商品
    //套餐包
    postQueryPackProduct: (params) => myAjax.post(`product/queryPackProduct`, params),//套餐包中的商品   

    //店铺
    ShopCasegetShopAptitude: (params) => myAjax.get(`ShopCase/getShopAptitude/${params}`),//店铺信息
    customerquery: (params) => myAjax.get(`customer/query`),//店铺客服列表
    productAllProduct: (params) => myAjax.get(`product/AllProduct?${params}`),//店铺全部活动商品
    //订单
    orderinitOrder: (params) => myAjax.get(`order/initOrder/${params}`),//订单明细（提交订单）
    orderfreight: (params) => myAjax.post(`order/freight`, params),//计算运费
    orderexpressFreight: (params) => myAjax.post(`order/expressFreight`, params),//按重量计算运费
    paymethoduse: () => myAjax.get(`paymethod/use`),//支付类型
    paywxpayMWEB: (params) => myAjax.post(`pay/wxpayMWEB`, params),//提交订单
    paywxpayApp: (params) => myAjax.post(`pay/wxpayApp`, params),//微信H5支付
    zfbWappay: (params) => myAjax.post(`zfbWap/pay`, params),//支付宝H5支付
    ordergetPayType: (params) => myAjax.get(`order/getPayType?${params}`),//查询订单
    paywxorder: (params) => myAjax.post(`pay/wxorder?${params}`),//查询微信支付订单
    zfbWapzfbOrder: (params) => myAjax.post(`zfbWap/zfbOrder?${params}`),//查询支付宝支付订单
    orderorderSui: (params) => myAjax.get(`order/orderSui?orderId=${params}`,),//查询随货资质
    orderaddQualific: (params) => myAjax.post(`order/addQualific`, params),//添加随货资质
    orderqueryQualific: () => myAjax.post(`order/queryQualific`),//随货资质类型列表
    orderqueryDiscount: params => myAjax.post(`order/queryDiscount`,params),//查询折扣金额
    ordergrouporder: params => myAjax.post(`order/grouporder`,params),//立即参团
    ordergroupRecord: params => myAjax.post(`order/groupRecord/${params}`),//拼团人数
    //我的
    headImgqueryByUser: params => myAjax.get(`headImg/queryByUser?${params}`),//头像
    headImgupdateHeadImg: params => myAjax.post(`headImg/updateHeadImg`,params),//设置头像
    headImgqueryAll: () => myAjax.get(`headImg/queryAll`),//头像列表
    ordercount: (params) => myAjax.get(`order/count?${params}`),//数量组
    coupconusable: (params) => myAjax.get(`coupcon/usable?${params}`),//优惠券数量
    buyerMemberqueryList: () => myAjax.post(`buyerMember/queryList`),//会员级别
    //排行榜
    producttops: () => myAjax.post(`product/tops`),//排行榜
    //退货退款
    refundPaygetBuyerRefund: params => myAjax.post(`refundPay/getBuyerRefund/${params}`),//查询退款状态
    refundPaycancelBuyerRefund: params => myAjax.post(`refundPay/cancelBuyerRefund/${params}`),//取消退货
    refundPaysetLogOrderNo: params => myAjax.post(`refundPay/setLogOrderNo`, params),//更新物流
    buyerviewPage: params => myAjax.post(`buyer/viewPage`, params),//页面记录
    buyervisits: params => myAjax.get(`buyer/visits?${params}`),//客户访问记录
    //抽奖
    lotteryList: () => myAjax.get(`lottery/list`),//奖品查询
    lotteryGetPrize: () => myAjax.post(`lottery/getPrize`),//开始抽奖
    lotteryConfigList: () => myAjax.get(`lotteryConfig/list`),//抽奖规则
    buyerBuyerPrize:() => myAjax.get(`buyer/buyerPrize`),//查询当前客户的次数
    userLotteryRecordList:(params) => myAjax.post(`userLotteryRecord/list`,params),//查询当前客户的领取
    //直播
    livelinkQuery:(params) => myAjax.post(`livelink/query`,params),//查询
    //下载资质
    ShopCaseDownloadAptitude:(params) => myAjax.get(`ShopCase/downloadAptitude?${params}`,),//查询
}
export default myaxios



// WEBPACK FOOTER //
// ./src/axios/api.js